import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Data from "../../dummy";
import PaginatedJobs from "./PaginatedJobs";
import MultiRangeSlider from "../multirangeslider/MultiRangeSlider";
import FormProcessingSpinner from "../../common/FormProcessingSpinner";
import SigninPopup from "../../common/SiginPopup";
import { useSelector } from "react-redux";
import SubscriptionPopup from "../../common/SubscribePopup";
import * as paths from "../../../constants/paths";

const JobList = ({
  data,
  jobs,
  cities,
  types,
  cats,
  searchJobs,
  degree_req,
  isSearching,
  saveJob,
  isJobSaving,
  industries,
  isJobApplying,
  handleJobApply,
  isJobReporting,
  handleReportAnJob,
  handleShowSigninPopup,
  showSigninPopup,
  showReportPopup,
  handleToggleReportPopup,
  totalJobs,
  is_global_val
}) => {
  let defaultTypesState = {};
  let defaultSubTypes = {};
  // cats.map((cat) => {
  //   return (defaultTypesState[cat.id] = true);
  // });

  // cats.map((cat) => {
  //   return cat.sub_cats.map((row) => {
  //     return (defaultSubTypes[row.id] = true);
  //   });
  // });
  const searchField = useRef(null);
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const plan = useSelector((state) => state.fetchSiteSettings.plan);
  const [showSubscripitionPopup, setShowSubscriptionPopup] = useState(false);

  const { icon, icon_alt, btn, flag, flag_alt } = Data.srch_bar;
  const [searchParams] = useSearchParams();
  const { page } = useParams();
  const [active, setActive] = useState(false);
  const [sortBy, setSortBy] = useState("desc");
  const [jobCats, setJobCats] = useState({});
  const [jobRequirements, setJobRequirements] = useState({});
  const [citiesFilter, setCitiesFilter] = useState({});
  const [tpyesFilter, settypesFilter] = useState(defaultTypesState);
  const [subTypesFilter, setSubTypesFilter] = useState(defaultSubTypes);
  const [visaAcceptance, setVisaAcceptance] = useState(false);
  const [applicantsOutUk, setApplicantsOutUk] = useState(false);
  const [search, setSearch] = useState(searchParams.get("search"));
  const [searchByField, setSearchByField] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  // const [minPrice, setMinPrice] = useState(0);
  // const [maxPrice, setMaxPrice] = useState(100000);
  const [filter, setFilter] = useState(false);
  const [is_global, setIsGlobal] = useState(
    searchParams.get("global") === "true" || searchParams.get("global") === true
      ? 1
      : searchParams.get("is_global") === "true" ||
        searchParams.get("is_global") === true
      ? 1
      : 0
  );
  const NO_OF_BLOCKS = 4;
  const [firstJobsIndex, setFirstJobsIndex] = useState(NO_OF_BLOCKS);
  const filteredIndustries = industries.slice(0, firstJobsIndex);

  const [secondJobsIndex, setSecondJobsIndex] = useState(NO_OF_BLOCKS);
  const filteredLocations = cities.slice(0, secondJobsIndex);
  const [pageNo, setPageNo] = useState(page);
  const isAlreadyInBasePath =
    typeof window !== "undefined" &&
    window.location.pathname.includes(`${paths.SITE_BASE_URL}`);
  const basePath = isAlreadyInBasePath ? "" : `${paths.SITE_BASE_URL}`;
  const ToggleFilter = () => {
    setFilter(!filter);
  };
  // useEffect(() => {
  //   cats.map((cat) => {
  //     tpyesFilter[cat.id] = true;
  //   });
  // }, []);

  if (searchParams.has("search")) {
    if (!plan) {
      navigate(basePath + "/subscription");
    }
  }

  const LoadMoreFirst = () => {
    setFirstJobsIndex(industries.length);
  };

  const LoadMoreSecond = () => {
    setSecondJobsIndex(cities.length);
  };

  const resetFirst = () => {
    setFirstJobsIndex(NO_OF_BLOCKS);
  };

  const resetSecond = () => {
    setSecondJobsIndex(NO_OF_BLOCKS);
  };

  const toggleFilter = () => {
    setActive(!active);
  };

  const handleJobCatsChange = (event) => {
    setIsFilterApplied(true);
    setJobCats({
      ...jobCats,
      [event.target.id]: event.target.checked,
    });
  };

  const handleDegreeRequirementChange = (event) => {
    setIsFilterApplied(true);
    setJobRequirements({
      ...jobRequirements,
      [event.target.id]: event.target.checked,
    });
  };

  const handleCityChange = (event) => {
    setIsFilterApplied(true);

    setCitiesFilter({
      ...citiesFilter,
      [event.target.id]: event.target.checked,
    });
  };

  const handleTypesChange = (event, sub_cats) => {
    // setIsFilterApplied(true);

    let typesCurrent = { ...subTypesFilter };
    sub_cats.map((row) => {
      return (typesCurrent = {
        ...typesCurrent,
        [event.target.id + "-" + row.id]: event.target.checked,
      });
    });

    setSubTypesFilter(typesCurrent);
    settypesFilter({
      ...tpyesFilter,
      [event.target.id]: event.target.checked,
    });
  };

  const handleSubtypesChangeChange = (event, sub_cats) => {
    // setIsFilterApplied(true);
    let mainCat = event.target.getAttribute("data-cat");
    let subCatsId = [];

    sub_cats.map((row) => {
      return subCatsId.push(parseInt(row.id));
    });

    let subTypesCurrent = {};
    subTypesCurrent = {
      ...subTypesFilter,
      [event.target.id]: event.target.checked,
    };

    if (event.target.checked) {
      let checkedSubCatsLength = 0;
      for (let prop in subTypesCurrent) {
        prop = parseInt(prop);
        if (subCatsId.includes(prop)) {
          if (subTypesCurrent[prop]) {
            checkedSubCatsLength++;
          }
        }
      }

      if (checkedSubCatsLength === sub_cats.length) {
        settypesFilter({
          ...tpyesFilter,
          [mainCat]: true,
        });
      }
    } else {
      settypesFilter({
        ...tpyesFilter,
        [mainCat]: false,
      });
    }

    setSubTypesFilter({
      ...subTypesFilter,
      [event.target.id]: event.target.checked,
    });
  };

  const handleSearchChange = (event) => {
    setIsFilterApplied(true);
    setSearch(event.target.value);
  };

  const handleSetVisaAcceptance = () => {
    setIsFilterApplied(true);
    setVisaAcceptance(!visaAcceptance);
  };

  const handleSetApplicantsOutUk = () => {
    setIsFilterApplied(true);
    setApplicantsOutUk(!applicantsOutUk);
  };

  const handleToggleSubscriptionPopup = () => {
    setShowSubscriptionPopup(!showSubscripitionPopup);
  };

  const handleSearchFromField = () => {
    if (!plan) {
      // window.location.replace("/subscription");

      navigate(basePath + "/subscription");

      return false;
    }

    setIsFilterApplied(true);
    // navigate(basePath + "/open-jobs/1");
    // Only claim it when the page actually changes - otherwise the flag would
    // linger and swallow the next genuine pagination search.
    if (Number(pageNo) !== 1) filterHandlerOwnsSearch.current = true;
    setPageNo(1);
    const params = Object.fromEntries([...searchParams.entries()]);
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }
    handleSearchJobs(isGlobal);
  };

  // document.addEventListener("keypress", (e) => {
  //   if (e.code === "Enter") {
  //     if (document.activeElement === searchField.current) {
  //       e.preventDefault();
  //       handleSearchFromField();
  //     }
  //   }
  // });

  const handleSearchFormSubmit = (e) => {
    e.preventDefault();
    handleSearchFromField();
  };

  const handleSortByChange = (val) => {
    ToggleFilter();
    setSortBy(val);
  };

  const handleApplyFilters = () => {
    if (!plan) {
      // window.location.replace("/subscription");

      navigate(basePath + "/subscription");
      return false;
    }

    // navigate(basePath + "/open-jobs/1");
    // Only claim it when the page actually changes - otherwise the flag would
    // linger and swallow the next genuine pagination search.
    if (Number(pageNo) !== 1) filterHandlerOwnsSearch.current = true;
    setPageNo(1);
    const params = Object.fromEntries([...searchParams.entries()]);
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }
    handleSearchJobs(isGlobal);
  };

  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()]);
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }
    const paramsObject = getUrlParamsObject();

    handleSearchJobs(isGlobal, paramsObject);
  }, [sortBy, is_global]);

  const handleClearAllFilter = () => {
    setSortBy("desc");
    setJobCats({});
    setJobRequirements({});
    setCitiesFilter({});
    settypesFilter({});
    setSubTypesFilter({});
    setVisaAcceptance(false);
    setApplicantsOutUk(false);
    // setSearch(searchParams.get("search"));
    setSearch(null);
    //call search
    setIsFilterApplied(false);
    const params = Object.fromEntries([...searchParams.entries()]);
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }
    // Setters above are async: calling handleSearchJobs() here would search
    // with the filters we just cleared. Let the effect run it afterwards.
    setPendingSearch(true);
  };
  // Two effects below both run on mount and both search: [sortBy, is_global]
  // and [pageNo]. Letting both fire means every page load hits the most
  // expensive endpoint on the site twice. The first one to run on mount does
  // the search; the other skips its first run and behaves normally afterwards.
  const pageNoEffectMounted = useRef(false);
  // Applying filters resets the page to 1. When the user was on page 2+ that
  // is a real pageNo change, so the [pageNo] effect would search a second time
  // for the same click. The handlers set this flag to claim the search.
  const filterHandlerOwnsSearch = useRef(false);

  // --- empty state -------------------------------------------------------
  // When a search returns nothing, the page used to be a dead end. These let
  // the member drop one filter (or all of them) and try again. State setters
  // are async, so the search is requested via a flag and run from an effect,
  // once the new filter state has been applied.
  const [pendingSearch, setPendingSearch] = useState(false);

  useEffect(() => {
    if (!pendingSearch) return;
    setPendingSearch(false);
    if (Number(pageNo) !== 1) filterHandlerOwnsSearch.current = true;
    setPageNo(1);
    handleSearchJobs(is_global);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingSearch]);

  const dropKey = (obj, key) => {
    const next = { ...obj };
    delete next[key];
    return next;
  };

  const subTypeLabel = (key) => {
    const [catId, subId] = String(key).split("-");
    const cat = (cats || []).find((c) => String(c.id) === catId);
    const sub = cat?.sub_cats?.find((x) => String(x.id) === subId);
    return sub?.title || cat?.title || "Job level";
  };

  // Filter keys carry the checkbox prefix ("industry-7", "city-2", "degree-2")
  // while the lists are keyed on the bare id.
  const lookupTitle = (list, id) => {
    const bare = String(id).replace(/^(industry|city|degree)-/, "");
    return (list || []).find((x) => String(x.id) === bare)?.title;
  };

  const activeFilters = [];
  Object.keys(jobCats || {}).forEach((k) => {
    if (jobCats[k])
      activeFilters.push({
        key: "cat-" + k,
        label: "Industry: " + (lookupTitle(industries, k) || k),
        remove: () => {
          setJobCats(dropKey(jobCats, k));
          setPendingSearch(true);
        },
      });
  });
  Object.keys(citiesFilter || {}).forEach((k) => {
    if (citiesFilter[k])
      activeFilters.push({
        key: "city-" + k,
        label: "Location: " + (lookupTitle(cities, k) || k),
        remove: () => {
          setCitiesFilter(dropKey(citiesFilter, k));
          setPendingSearch(true);
        },
      });
  });
  Object.keys(subTypesFilter || {}).forEach((k) => {
    if (subTypesFilter[k])
      activeFilters.push({
        key: "sub-" + k,
        label: "Level: " + subTypeLabel(k),
        remove: () => {
          setSubTypesFilter(dropKey(subTypesFilter, k));
          setPendingSearch(true);
        },
      });
  });
  Object.keys(jobRequirements || {}).forEach((k) => {
    if (jobRequirements[k])
      activeFilters.push({
        key: "req-" + k,
        label: "Requirement: " + (lookupTitle(degree_req, k) || k),
        remove: () => {
          setJobRequirements(dropKey(jobRequirements, k));
          setPendingSearch(true);
        },
      });
  });
  if (visaAcceptance)
    activeFilters.push({
      key: "visa",
      label: "Accepts visa sponsorship",
      remove: () => {
        setVisaAcceptance(false);
        setPendingSearch(true);
      },
    });
  if (applicantsOutUk)
    activeFilters.push({
      key: "outside",
      label: "Open to applicants outside the UK",
      remove: () => {
        setApplicantsOutUk(false);
        setPendingSearch(true);
      },
    });

  const activeKeyword =
    search && search !== "null" && String(search).trim() !== ""
      ? String(search).trim()
      : null;


  const noJobsPanel = (
    <div className="msg_no_jobs">
      {activeFilters.length > 0 || activeKeyword ? (
        <>
          <p>
            <strong>No jobs match all of these filters.</strong> Try removing
            one - most searches open up with a single change:
          </p>
          <p className="no_jobs_chips">
            {activeKeyword && (
              <button
                type="button"
                className="chip"
                onClick={() => {
                  setSearch(null);
                  setPendingSearch(true);
                }}
              >
                Keyword: {activeKeyword} <span aria-hidden="true">&times;</span>
              </button>
            )}
            {activeFilters.map((f) => (
              <button
                type="button"
                className="chip"
                key={f.key}
                onClick={f.remove}
              >
                {f.label} <span aria-hidden="true">&times;</span>
              </button>
            ))}
            <button
              type="button"
              className="chip clear_all"
              onClick={handleClearAllFilter}
            >
              {activeKeyword
                ? `Search "${activeKeyword}" without filters`
                : "Clear all filters"}
            </button>
          </p>
          <p className="small">
            Still nothing? Set up a <Link to="/job-alerts">job alert</Link> and
            we will email you as soon as a matching role is posted.
          </p>
        </>
      ) : (
        <>
          No jobs match your search right now. We update listings daily. Set up
          a <Link to="/job-alerts">job alert</Link> and we will email you when a
          matching role is posted.
        </>
      )}
    </div>
  );

  const getUrlParamsObject = () => {
    const paramsObject = {};
    // ✅ Read parameters from the URL
    const params = Object.fromEntries([...searchParams.entries()]);
    // ✅ Example: search term
    if (params.searchKeyword) {
      paramsObject.searchKeyword = params.searchKeyword;
    }
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      paramsObject.is_global = 1;
    } else {
      paramsObject.is_global = 0;
    }

    // ✅ Example: job categories (comma-separated IDs)
    if (params.jobCats) {
      const jobCatsFromUrl = {};
      params.jobCats.split(",").forEach((id) => {
        jobCatsFromUrl[id] = true;
      });
      paramsObject.jobCats = jobCatsFromUrl;
    }

    // ✅ Example: cities filter
    if (params.cities) {
      const citiesFromUrl = {};
      params.cities.split(",").forEach((id) => {
        citiesFromUrl[id] = true;
      });
      paramsObject.cities = citiesFromUrl;
    }

    // ✅ Example: job types
    if (params.types) {
      const typesFromUrl = {};
      params.types.split(",").forEach((id) => {
        typesFromUrl[id] = true;
      });
      paramsObject.types = typesFromUrl;
    }

    // ✅ Example: sub types
    if (params.subTypes) {
      const subTypesFromUrl = {};
      params.subTypes.split(",").forEach((id) => {
        subTypesFromUrl[id] = true;
      });
      paramsObject.subTypes = subTypesFromUrl;
    }

    // ✅ Example: degree requirements
    if (params.jobRequirements) {
      const reqFromUrl = {};
      params.jobRequirements.split(",").forEach((id) => {
        reqFromUrl[id] = true;
      });
      paramsObject.jobRequirements = reqFromUrl;
    }

    // ✅ Example: boolean filters
    if (params.visaAcceptance === "true") {
      paramsObject.visaAcceptance = true;
    }
    if (params.applicants_outside_uk === "true") {
      paramsObject.applicants_outside_uk = true;
    }

    // ✅ Sort By
    if (params.sortBy) {
      paramsObject.sortBy = params.sortBy;
    }

    // ✅ Page number
    if (params.pageNo) {
      paramsObject.pageNo = Number(params.pageNo);
    }
    return paramsObject;
  };
  useEffect(() => {
    // ✅ Read parameters from the URL
    const params = Object.fromEntries([...searchParams.entries()]);
    // ✅ Example: search term
    if (params.searchKeyword) {
      setSearch(params.searchKeyword);
    }
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }

    // ✅ Example: job categories (comma-separated IDs)
    if (params.jobCats) {
      const jobCatsFromUrl = {};
      params.jobCats.split(",").forEach((id) => {
        jobCatsFromUrl[id] = true;
      });
      setJobCats(jobCatsFromUrl);
    }

    // ✅ Example: cities filter
    if (params.cities) {
      const citiesFromUrl = {};
      params.cities.split(",").forEach((id) => {
        citiesFromUrl[id] = true;
      });
      setCitiesFilter(citiesFromUrl);
    }

    // ✅ Example: job types
    if (params.types) {
      const typesFromUrl = {};
      params.types.split(",").forEach((id) => {
        typesFromUrl[id] = true;
      });
      settypesFilter(typesFromUrl);
    }

    // ✅ Example: sub types
    if (params.subTypes) {
      const subTypesFromUrl = {};
      params.subTypes.split(",").forEach((id) => {
        subTypesFromUrl[id] = true;
      });
      setSubTypesFilter(subTypesFromUrl);
    }

    // ✅ Example: degree requirements
    if (params.jobRequirements) {
      const reqFromUrl = {};
      params.jobRequirements.split(",").forEach((id) => {
        reqFromUrl[id] = true;
      });
      setJobRequirements(reqFromUrl);
    }

    // ✅ Example: boolean filters
    if (params.visaAcceptance === "true") {
      setVisaAcceptance(true);
    }
    if (params.applicants_outside_uk === "true") {
      setApplicantsOutUk(true);
    }

    // ✅ Sort By
    if (params.sortBy) {
      setSortBy(params.sortBy);
    }

    // ✅ Page number
    // if (params.pageNo) {
    //   setPageNo(Number(params.pageNo));
    // }
    const paramsObject = getUrlParamsObject();
    // ✅ After setting filters, fetch jobs
    handleSearchJobs(isGlobal, paramsObject);
  }, []);
  const handleSearchJobs = (isGlobal = null, paramsObject = null) => {
    setActive(false);
    // alert();

    let jobCatsArr = [];
    for (let key in jobCats) {
      if (jobCats[key]) jobCatsArr.push(key);
    }
    if (jobCatsArr.length === 0 && paramsObject && paramsObject.jobCats) {
      for (let key in paramsObject.jobCats) {
        if (paramsObject.jobCats[key]) jobCatsArr.push(key);
      }
    }

    let citiesFilterArr = [];
    for (let key in citiesFilter) {
      if (citiesFilter[key]) citiesFilterArr.push(key.toString());
    }
    if (citiesFilterArr.length === 0 && paramsObject && paramsObject.cities) {
      for (let key in paramsObject.cities) {
        if (paramsObject.cities[key]) citiesFilterArr.push(key);
      }
    }

    let tpyesFilterArr = [];
    for (let key in tpyesFilter) {
      if (tpyesFilter[key]) tpyesFilterArr.push(key.toString());
    }
    if (tpyesFilterArr.length === 0 && paramsObject && paramsObject.types) {
      for (let key in paramsObject.types) {
        if (paramsObject.types[key]) tpyesFilterArr.push(key);
      }
    }

    let subTypesFilterArr = [];
    for (let key in subTypesFilter) {
      if (subTypesFilter[key]) subTypesFilterArr.push(key.toString());
    }
    if (
      subTypesFilterArr.length === 0 &&
      paramsObject &&
      paramsObject.subTypes
    ) {
      for (let key in paramsObject.subTypes) {
        if (paramsObject.subTypes[key]) subTypesFilterArr.push(key);
      }
    }

    let degreeRequirementsArr = [];
    for (let key in jobRequirements) {
      if (jobRequirements[key]) degreeRequirementsArr.push(key.toString());
    }
    if (
      degreeRequirementsArr.length === 0 &&
      paramsObject &&
      paramsObject.jobRequirements
    ) {
      for (let key in paramsObject.jobRequirements) {
        if (paramsObject.jobRequirements[key]) degreeRequirementsArr.push(key);
      }
    }

    let filters = {};
    filters = {
      sortBy: sortBy,
      jobCats: jobCatsArr,
      cities: citiesFilterArr,
      types: tpyesFilterArr,
      jobRequirements: degreeRequirementsArr,
      visaAcceptance: visaAcceptance,
      applicants_outside_uk: applicantsOutUk,
      searchKeyword: search,
      subTypes: subTypesFilterArr,
      // minPrice: minPrice,
      // maxPrice: maxPrice
      pageNo: pageNo,
      is_global: is_global
        ? is_global
        : isGlobal !== null
        ? isGlobal
        : is_global,
    };
    if (
      filters?.searchKeyword === null ||
      filters?.searchKeyword === "null" ||
      filters?.searchKeyword === undefined ||
      filters?.searchKeyword === "undefined"
    ) {
      const params = Object.fromEntries([...searchParams.entries()]);
      if (params.searchKeyword) {
        filters.searchKeyword = params.searchKeyword;
      }
    }
    // console.log("paramsObject", paramsObject);
    filters = { ...paramsObject, ...filters };
    // console.log("filters", filters,);
    searchJobs(filters);
  };

  useEffect(() => {
    const params = Object.fromEntries([...searchParams.entries()]);
    let isGlobal = null;
    if (
      (params.is_global &&
        params.is_global !== undefined &&
        params.is_global !== "undefined" &&
        params.is_global !== null &&
        params.is_global !== "null" &&
        params.is_global !== true &&
        params.is_global !== "true" &&
        params.is_global !== "0" &&
        params.is_global !== 0) ||
      params.is_global === 1 ||
      params.global === "1"
    ) {
      setIsGlobal(1);
      isGlobal = 1;
    } else {
      setIsGlobal(0);
    }

    if (pageNo > 2 && !plan) {
      navigate(basePath + "/subscription");
    } else if (!pageNoEffectMounted.current) {
      // First render: the [sortBy, is_global] effect already searches.
      pageNoEffectMounted.current = true;
    } else if (filterHandlerOwnsSearch.current) {
      // The filter handler that reset the page has already run the search.
      filterHandlerOwnsSearch.current = false;
    } else {
      const paramsObject = getUrlParamsObject();
      handleSearchJobs(isGlobal, paramsObject);
    }
  }, [pageNo]);

  return (
    <>
      <section id="open_jobs">
        <div className="top_blk">
          <div className="contain">
            <form
              action="/open-jobs/1"
              onSubmit={handleSearchFormSubmit}
              method="POST"
              id="srch_bar"
            >
              <div className="inside input">
                {/* <div className="flag_blk d-inline-flex align-items-center">
                  UK <img src={flag} alt={flag_alt} />
                </div> */}
                <div className="form_blk">
                  <img
                    src={paths.SITE_BASE_URL + "/images/new/search-normal.svg"}
                    alt={icon_alt}
                  />
                  <input
                    type="text"
                    name="search"
                    id="search"
                    value={search}
                    onChange={handleSearchChange}
                    className="input"
                    placeholder="Job, Company, Location"
                    autoComplete="off"
                    ref={searchField}
                  />
                </div>
                <button
                  type="submit"
                  className="site_btn"
                  // onClick={() => setSearchByField(!searchByField)}
                  onClick={handleSearchFromField}
                  disabled={isSearching}
                >
                  {btn}
                </button>
              </div>
            </form>
          </div>
        </div>
        <div className="jobs_page" id="job__block">
          <div className="contain">
            <div className="flex">
              <div className="filter_wrapper_col colL">
                <div id="filter" className={active ? "active" : ""}>
                  <button
                    type="button"
                    className="x_btn"
                    onClick={toggleFilter}
                  ></button>
                  <div className="top_head mb-0">
                    <h4 className="mb-0">Filter Jobs</h4>
                    <button
                      onClick={handleClearAllFilter}
                      className="clear_filter"
                      disabled={isSearching}
                    >
                      Clear All
                    </button>
                  </div>
                  <div className="in_blk">
                    <h6>Job Type</h6>
                    <ul className="ctg_lst">
                      {cats.map((cat, key) => (
                        <li key={key}>
                          <label htmlFor={cat.id}>
                            <input
                              type="checkbox"
                              value={cat.id}
                              id={cat.id}
                              name="job_type"
                              onChange={(e) =>
                                handleTypesChange(e, cat.sub_cats)
                              }
                              checked={tpyesFilter[cat.id]}
                            />
                            {cat.title} <span>({cat.count})</span>
                          </label>
                          <ul>
                            {cat.sub_cats &&
                              cat.sub_cats.map((sub) => (
                                <li>
                                  <div className="lbl_btn">
                                    <input
                                      data-cat={cat.id}
                                      type="checkbox"
                                      value={sub.id}
                                      id={cat.id + "-" + sub.id}
                                      name="job_sub"
                                      onChange={(e) =>
                                        handleSubtypesChangeChange(
                                          e,
                                          cat.sub_cats
                                        )
                                      }
                                      checked={
                                        subTypesFilter[cat.id + "-" + sub.id]
                                      }
                                    />
                                    <label htmlFor={cat.id + "-" + sub.id}>
                                      {sub.title}
                                    </label>
                                  </div>
                                </li>
                              ))}
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {is_global === 0 && (
                    <>
                      <div className="in_blk">
                        <h6>Degree Requirement</h6>
                        <ul className="ctg_lst">
                          {degree_req.map((dr, key) => (
                            <li key={key}>
                              <label htmlFor={"degree-" + dr.id}>
                                <input
                                  type="checkbox"
                                  value={dr.id}
                                  id={"degree-" + dr.id}
                                  name="degree_req"
                                  onChange={handleDegreeRequirementChange}
                                  checked={
                                    jobRequirements[dr.id] ||
                                    jobRequirements["degree-" + dr.id]
                                  }
                                />
                                {dr.title}
                                <span>({dr.count})</span>
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  )}
                  <div className="in_blk">
                    <h6>Job Industry</h6>
                    <ul className="ctg_lst">
                      {filteredIndustries.map((industry, key) => (
                        <li key={key}>
                          <label htmlFor={"industry-" + industry.id}>
                            <input
                              type="checkbox"
                              value={industry.id}
                              id={"industry-" + industry.id}
                              name="job_cat"
                              onChange={handleJobCatsChange}
                              checked={
                                jobCats[industry.id] ||
                                jobCats["industry-" + industry.id]
                              }
                            />
                            {industry.title} <span>({industry.count})</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                    {industries.length > NO_OF_BLOCKS && (
                      <button
                        onClick={
                          firstJobsIndex === industries.length
                            ? resetFirst
                            : LoadMoreFirst
                        }
                        className="view_more_new"
                      >
                        {firstJobsIndex === industries.length
                          ? "View Less"
                          : "View All"}
                      </button>
                    )}
                  </div>
                  <div className="in_blk">
                    <h6>Location</h6>
                    <ul className="ctg_lst">
                      {filteredLocations.map((city, key) => (
                        <li key={key}>
                          <label htmlFor={"city-" + city.id}>
                            <input
                              type="checkbox"
                              value={city.id}
                              id={"city-" + city.id}
                              name="city"
                              onChange={handleCityChange}
                              checked={
                                citiesFilter[city.id] ||
                                citiesFilter["city-" + city.id]
                              }
                            />
                            {city.title} <span>({city.count})</span>
                          </label>
                        </li>
                      ))}
                    </ul>
                    {cities.length > NO_OF_BLOCKS && (
                      <button
                        onClick={
                          secondJobsIndex === cities.length
                            ? resetSecond
                            : LoadMoreSecond
                        }
                        className="view_more_new"
                      >
                        {secondJobsIndex === cities.length
                          ? "View Less"
                          : "View All"}
                      </button>
                    )}
                  </div>
                  {is_global === 0 && (
                    <>
                      <div className="in_blk">
                        <h6>Suitable For</h6>
                        <ul className="ctg_lst">
                          <li>
                            <label htmlFor="visa_acceptance">
                              <input
                                type="checkbox"
                                id="visa_acceptance"
                                name="visa_acceptance"
                                onClick={handleSetVisaAcceptance}
                                checked={visaAcceptance}
                              />
                              Graduate Visa holders
                            </label>
                          </li>
                          <li>
                            <label htmlFor="applicants_outside_uk">
                              <input
                                type="checkbox"
                                id="applicants_outside_uk"
                                name="applicants_outside_uk"
                                onClick={handleSetApplicantsOutUk}
                                checked={applicantsOutUk}
                              />
                              Applicants based outside the UK
                            </label>
                          </li>
                        </ul>

                        {/* <h6>Suitable For</h6>
                    <ul className="ctg_lst">
                      <li>
                        <label htmlFor="visa_acceptance">
                          <input
                            type="checkbox"
                            id="visa_acceptance"
                            name="visa_acceptance"
                            onClick={handleSetVisaAcceptance}
                            checked={visaAcceptance}
                          />
                          Graduate Visa holders
                        </label>
                      </li>
                      <li>
                        <label htmlFor="applicants_outside_uk">
                          <input
                            type="checkbox"
                            id="applicants_outside_uk"
                            name="applicants_outside_uk"
                            onClick={handleSetApplicantsOutUk}
                            checked={applicantsOutUk}
                          />
                          Applicants based outside the UK
                        </label>
                      </li>
                    </ul> */}
                      </div>
                    </>
                  )}
                  <div className="in_blk">
                    <div className="btn_blk text-left">
                      <button
                        className="site_btn"
                        onClick={handleApplyFilters}
                        disabled={isSearching}
                      >
                        <FormProcessingSpinner isFormProcessing={isSearching} />
                        Apply Filters
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="colR">
                <div className="top_head main_filter flex">
                  <h5>
                    {totalJobs == 0
                      ? "0 record."
                      : "Showing " +
                        ((pageNo - 1) * 15 + 1) +
                        " to " +
                        ((pageNo - 1) * 15 + jobs.length) +
                        " of " +
                        totalJobs +
                        (totalJobs === 1 ? " role" : " roles")}
                  </h5>
                  <div className="inner_filter_main">
                    <span>Sort by :</span>
                    <div className="drop">
                      <div className="drop_btn" onClick={ToggleFilter}>
                        <h6>
                          {sortBy == "desc" ? "Most Recent" : "Least Recent"}
                        </h6>
                        <div className="drop_arrow">
                          <img
                            src={
                              paths.SITE_BASE_URL +
                              "/images/new/arrow-down-filter.svg"
                            }
                            alt=""
                          />
                        </div>
                      </div>
                      <div className={filter ? "drop_cnt active" : "drop_cnt"}>
                        <ul className="drop_lst">
                          <li
                            onClick={() => handleSortByChange("desc")}
                            style={{ cursor: "pointer" }}
                          >
                            Most Recent
                          </li>
                          <li
                            onClick={() => handleSortByChange("asc")}
                            style={{ cursor: "pointer" }}
                          >
                            Least Recent
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <PaginatedJobs
                  data={data}
                  jobs={jobs}
                  isSearching={isSearching}
                  saveJob={saveJob}
                  isJobSaving={isJobSaving}
                  itemsPerPage={15}
                  isJobApplying
                  handleJobApply
                  isJobReporting={isJobReporting}
                  handleReportAnJob={handleReportAnJob}
                  handleShowSigninPopup={handleShowSigninPopup}
                  showSigninPopup={showSigninPopup}
                  showReportPopup={showReportPopup}
                  handleToggleReportPopup={handleToggleReportPopup}
                  setPageNo={setPageNo}
                  pageNo={pageNo}
                  totalJobs={totalJobs}
                  is_global_val={is_global_val}
                  noJobsPanel={noJobsPanel}
                />
              </div>
            </div>
            <div id="filter_btn_blk" className="btn_blk">
              <button
                type="button"
                id="filter_btn"
                className="site_btn auto"
                onClick={toggleFilter}
              >
                <img
                  src={process.env.PUBLIC_URL + "/images/icon-slider.svg"}
                  alt=""
                />
                View Filters
              </button>
            </div>
          </div>
        </div>
      </section>
      {showSigninPopup && (
        <SigninPopup handleShowSigninPopup={handleShowSigninPopup} />
      )}
      {showSubscripitionPopup && (
        <SubscriptionPopup
          handleToggleSubscriptionPopup={handleToggleSubscriptionPopup}
        />
      )}
    </>
  );
};

export default JobList;
